<script setup lang="ts">
/** TMP088 — Pricing for Allotment of Shares (DCR). 실제 변수: company, constitution_clause_number,
 *  share_price, dcr_date, Signers. 토글: OtcDcrIntro(is_sole/multiple_director_company + resolution_basis). */
import OtcDocVarField from './OtcDocVarField.vue';
import OtcDocHead from './parts/OtcDocHead.vue';
import OtcDcrIntro from './parts/OtcDcrIntro.vue';
import OtcSigners from './parts/OtcSigners.vue';
</script>

<template>
  <div class="allot-doc">
    <OtcDocHead />
    <OtcDcrIntro />

    <p class="doc-sec-title">PRICING FOR ALLOTMENT OF SHARES</p>
    <p class="doc-p"><b>RESOLVED:</b></p>
    <p class="doc-p">
      1. &nbsp; THAT pursuant to the authority and rights granted by the members of the company to allot and issue shares, the Director(s)
      be and is/are hereby authorised to fix its share pricing at RM<OtcDocVarField field-key="share_price" /> each
      (the “Price”) for the purpose of allotment of shares.
    </p>
    <p class="doc-p">
      2. &nbsp; THAT the secretary of the company be and is hereby authorised to prepare all relevant documents for the allotment of shares
      based on the Price stipulated hereof.
    </p>

    <OtcSigners var-key="pricing" board-label="BOARD OF DIRECTORS" />
    <p class="doc-p" style="margin-top:14px"><b>Date :</b> <OtcDocVarField field-key="dcr_date" /></p>
  </div>
</template>
